import React from "react";

// "cell" is the inline table/list variant (source's <td colSpan> pattern —
// consumed via AdminTableMessageRow, not directly). "card"/"grid" are the
// rounded-[2rem] centered-icon card used everywhere else in source.
export default function AdminEmptyState({ icon: Icon, title, subtitle, size = "card" }) {
  return (
    <div className={`rounded-[2rem] bg-white border border-[#E5DFC8] text-center ${size === "grid" ? "p-8" : "p-10"}`}>
      {Icon && <Icon className="w-10 h-10 text-hv-slate mx-auto" strokeWidth={2.2} />}
      <p className="mt-3 hv-heading text-lg text-hv-navy">{title}</p>
      {subtitle && <p className="text-hv-slate text-sm mt-1">{subtitle}</p>}
    </div>
  );
}
